import { ProgressStepper } from "components/ShipmentProgressSteps/progressStepper";

const SHIPMENT_PROGRESS_STEPS = [
  "POSTED",
  "NOTIFIED",
  "QUOTES",
  "BOOKED",
  "PICKED UP",
  "DELIVERED",
];

interface Props {
  shipment: ShipperCondensedShipment | undefined;
  progress: ShipmentProgress | null;
}

export function ShipmentProgressStepper(props: Props) {
  const { shipment, progress } = props;

  const getProgress = () => {
    if (!shipment || !progress) {
      return 0;
    }
    if (shipment.shipment_status === "DELIVERED") {
      return 5;
    }
    if (shipment.shipment_status === "PICKED_UP") {
      return 4;
    }
    if (
      shipment.shipment_status === "BOOKED" ||
      shipment.shipment_status === "BOOKING_CANCELLED"
    ) {
      return 3;
    }
    if (progress.quote_count > 0) {
      return 2;
    }
    return 1;
  };

  return (
    <ProgressStepper
      allSteps={SHIPMENT_PROGRESS_STEPS}
      progressValue={getProgress()}
      shipmentStatus={shipment?.shipment_status}
    />
  );
}
